import React, { useEffect } from 'react';
import MultiSelectDropdown from '../../components/multiSelectDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { addLicenseState, fetchInitialState, removeLicenseState } from './licenseStatesSlice';
import Loader from '../../components/loader';

var states = [
    "N/A",
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Puerto Rico",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
]

const LicenseStates = () => {
  const dispatch = useDispatch();
  const selectedOptionsState = useSelector(state => state.license_states)
  
  const toggleOption = (option) => {
    if (selectedOptionsState.data.includes(option)) {
      // Dispatch a remove action
      dispatch(removeLicenseState(option));
    } else {
      // Dispatch an add action
      dispatch(addLicenseState(option));
    }
  };

  useEffect(() => {
    dispatch(fetchInitialState())
  }, [dispatch])

  return (
    <>
        { selectedOptionsState.loading && <Loader /> }
        <div className="mt-4 flex flex-col items-center justify-center px-1 sm:mt-10">
            <h3 className="text-center text-2xl font-bold tracking-tight text-[#0a1445] sm:text-3xl">
              Please select the states you want to be licensed in!
            </h3>
            <MultiSelectDropdown 
                options={states} 
                placeholder={"Select one or more states"} 
                toggleOption={toggleOption}
                selectedOptions={selectedOptionsState.data}
              />

        </div>
    </>
  )
}

export default LicenseStates;
